export default __webpack_public_path__ + "static/media/8.c4e46b65.jpg";